<div class="myForm" [style.height]="data.id == 'clientEngagementReport' ? '' : data.id == 'clientCapacityReport' ? '' : ''">
  <div class="card">
    <h4 class="card-header">{{header}}</h4>
    <div class="card-body">
      <form #synopsisForm="ngForm" (ngSubmit)="download()">
        <p *ngIf="data.id == 'clientEngagementReport' || data.id == 'clientCapacityReport' || data.id == 'monthlyReport' || data.id == 'quarterlyReport' || data.id == 'annuallyReport'">
          <mat-form-field appearance="outline" color="primary">
            <mat-label>Client</mat-label>
            <mat-select name="client" placeholder="Client" [(ngModel)]="client" required>
              <mat-option *ngFor="let item of clients" [value]="item.id">{{
                item.dname
                }}</mat-option>
            </mat-select>
            <mat-error>*Client is required</mat-error>
          </mat-form-field>
        </p>
        <p *ngIf="data.id == 'quarterlyReport' || data.id == 'annuallyReport'">
          <mat-form-field appearance="outline" color="primary">
            <mat-label>Type</mat-label>
            <mat-select [(ngModel)]="selectedType" name="type" required>
              <mat-option value="client">Client</mat-option>
              <mat-option value="fleet">Fleet</mat-option>
            </mat-select>
            <mat-error>*Client type is required</mat-error>
          </mat-form-field>
        </p>
        <!-- Fleet Name Field (only shown if fleet is selected) -->
        <p *ngIf="selectedType == 'fleet' && data.id == 'quarterlyReport' || selectedType == 'fleet' && data.id == 'annuallyReport'">
          <mat-form-field appearance="outline" color="primary">
            <mat-label>Fleet Name</mat-label>
            <input matInput [(ngModel)]="fleetName" type="text" name="fleetName" required />
            <mat-error>*Fleet Name is required</mat-error>
          </mat-form-field>
        </p>
        <p *ngIf="data.id == 'clientEngagementReport' || data.id == 'monthlyReport'">
          <mat-form-field appearance="outline" color="primary">
            <mat-label>Report Type</mat-label>
            <mat-select name="reportType" placeholder="Report Type" [(ngModel)]="reportType" required>
              <mat-option *ngFor="let item of reportTypes" [value]="item">{{
                item
                }}</mat-option>
            </mat-select>
            <mat-error>*Report Type is required</mat-error>
          </mat-form-field>
        </p>
        <p *ngIf="data.id == 'quarterlyReport' || data.id == 'internalAdminPanel' || data.id == 'annuallyReport'|| data.id == 'monthlyReport'">
          <mat-form-field appearance="outline" color="primary">
            <mat-label>Start Date</mat-label>
            <input matInput [(ngModel)]="startDate" type="date" name="startDate" required />
            <mat-error>*Start Date is required</mat-error>
          </mat-form-field>
        </p>
        <p *ngIf="data.id == 'quarterlyReport' || data.id == 'internalAdminPanel' || data.id == 'annuallyReport' || data.id == 'monthlyReport'">
          <mat-form-field appearance="outline" color="primary">
            <mat-label>End Date</mat-label>
            <input matInput [(ngModel)]="endDate" type="date" name="endDate" required />
            <mat-error>*End Date is required</mat-error>
          </mat-form-field>
        </p>
        <p *ngIf="data.id == 'annuallyReport'">
          <mat-form-field appearance="outline" color="primary">
            <mat-label>Version</mat-label>
            <mat-select [(ngModel)]="version" name="version" required>
              <mat-option *ngFor="let item of versions" [value]="item">{{
                item
                }}</mat-option>
            </mat-select>
            <mat-error>*Version is required</mat-error>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field appearance="outline" color="primary">
            <mat-label>Comment</mat-label>
            <textarea matInput [(ngModel)]="comment" type="text" name="comment" required></textarea>
            <mat-error>*Comment is required</mat-error>
          </mat-form-field>
        </p>
        <p>
          <button color="primary" class="button" [disabled]="!synopsisForm.valid || buttonClicked" type="submit"
            mat-raised-button>
            {{ buttonClicked ? "Downloading" : "Download" }}
            <span>
              <mat-icon *ngIf="buttonClicked">
                <mat-spinner diameter="25"></mat-spinner>
              </mat-icon>
            </span>
          </button>
        </p>
      </form>
    </div>
  </div>
</div>